import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";

import type { AgencyDomain } from "../types";

async function getAgencyDomainRequest(
  domainName: string,
): Promise<AgencyDomain> {
  return (await get(`agency/domains/${domainName}`)).record;
}

export default function useAgencyDomain(domainName: string) {
  const { data: agencyDomain, isLoading: isLoadingAgencyDomain } = useQuery({
    queryKey: ["agencyDomain", domainName],
    queryFn: () => getAgencyDomainRequest(domainName),
  });

  return {
    agencyDomain,
    isLoadingAgencyDomain,
  };
}
